import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const extractVariableAction = createAsyncThunk(
    "extractVariable", async (args, { rejectWithValue }) => {
        try {
            const response = await doPost(urls.extractVariable, args);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const extractVariableSlice = createSlice({
    name: "extractVariable",
    initialState: {
        isLoading: false,
        success: false,
        error: false,
        data: false
    },
    reducers: {
        extractVariableReset: () => {
            return {
                isLoading: false,
                success: false,
                error: false,
                data: false
            }
        }
    },
    extraReducers: {
        [extractVariableAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.data = payload;
            state.error = false;
        },
        [extractVariableAction.pending]: (state) => {
            state.isLoading = true;
            state.data = false;
            state.error = null;
        },
        [extractVariableAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        }
    }
});

export const { extractVariableReset } = extractVariableSlice.actions;